
export async function getAliOSS() {
    return new Promise(resolve => {
        if (window.OSS) {
            resolve(window.OSS)
        } else {
            var script = document.createElement("script");

            script.src = "https://cdn01.xiaogj.com/uploads/x3/libs/official/oss/6.9.0/aliyun-oss-sdk.min.js"
            script.onload = e => resolve(window.OSS)
            script.onerror = err => {
                throw new Error("加载 aliyun-oss-sdk 失败!")
            }

            window.document.head.appendChild(script);
        }
    })
}


export  async function getExifJs() {
    return new Promise(resolve => {
        if (window.EXIF) {
            resolve(window.EXIF)
        } else {
            Promise.all([getExif(), getIsRotate()]).then(res => {
                console.log("EXIF 类库加载成功");
                resolve(window.EXIF)
            })
        }
    })
}


function getExif() {
    return new Promise(resolve => {
        if (window.EXIF) {
            resolve(window.EXIF)
        } else {
            var script = document.createElement("script");
            script.src = "https://cdn01.xiaogj.com/uploads/x3/libs/official/exif/2.3.0/exif.min.js"
            script.onload = e => resolve(window.EXIF)
            script.onerror = err => {
                throw new Error("加载 EXIF.js 失败!")
            }
            window.document.head.appendChild(script);
        }
    })
}


function getCroppieCss() {
    return new Promise(resolve => {
        var link = document.createElement("link")
        link.rel = "stylesheet"
        link.href = "https://cdn01.xiaogj.com/uploads/x3/libs/official/croppie/2.6.5/croppie.min.css"
        link.onload = e => resolve()
        link.onerror = err => {
            throw new Error("加载 croppie.css 失败!")
        }
        window.document.head.appendChild(link);
    })
}

function getCroppieJs() {
    return new Promise(resolve => {
        var script = document.createElement("script");
        script.src = "https://cdn01.xiaogj.com/uploads/x3/libs/official/croppie/2.6.5/croppie.min.js"
        script.onload = e => resolve(window.OSS)
        script.onerror = err => {
            throw new Error("加载 croppie.js 失败!")
        }
        window.document.head.appendChild(script);
    })
}

// 判断 游览器是否会自动根据图片的 EXIF信息中的Orientation 进行旋转
// 如果游览器进行了旋转就不需要处理，没有旋转就需要进行旋转
// window.imgIsRotate  1 代表游览器做了旋转，0代表游览器没有做处理
function getIsRotate() {
    return new Promise(resolve => {
        if (window.imgIsRotate !== undefined) {
            resolve()
        } else {
            let img = document.createElement('img');
            img.src = 'https://cdn01.xiaogj.com/uploads/x3/assets/img/fix-rotate/fix-rotate-img.jpg';
            img.onload = function () {
                if (img.width && img.width > 300) {
                    window.imgIsRotate = 1;
                } else {
                    window.imgIsRotate = 0;
                }
                resolve();
            }
            img.onerror = err => {
                window.imgIsRotate = 0;
                resolve();
            }
        }
    })
}

export  async function getCroppie() {
    return new Promise(resolve => {
        if (window.Croppie) {
            resolve(window.Croppie)
        } else {
            Promise.all([getCroppieCss(), getCroppieJs(), getExifJs()]).then(res => {
                console.log("croppie 类库加载成功");
                resolve(window.Croppie)
            })
        }
    })
}


// 异步获取echarts
export async function getEcharts() {
    return new Promise(resolve => {
        if (window.echarts) {
            resolve(window.echarts)
        } else {
            var script = document.createElement("script");

            script.src = "https://cdn01.xiaogj.com/uploads/x3/libs/official/echarts/5.0.0/echarts.min.js"
            script.onload = e => resolve(window.echarts)
            script.onerror = err => {
                throw new Error("加载 echarts 失败!")
            }

            window.document.head.appendChild(script);
        }
    })
}


// 异步获取qrcode
export async function getQrCodeJs() {
    return new Promise(resolve => {
        if (window.QRCode) {
            resolve(window.QRCode)
        } else {
            var script = document.createElement("script");

            script.src = "https://cdn01.xiaogj.com/uploads/x3/libs/official/qrcode/qrcode.min.js"
            script.onload = e => resolve(window.QRCode)
            script.onerror = err => {
                throw new Error("加载 qrcode.js 失败!")
            }
            window.document.head.appendChild(script);
        }
    })
}

// 异步获取arttemplate
export async function getArtTemplate() {
    return new Promise(resolve => {
        if (window.template) {
            resolve(window.template)
        } else {
            var script = document.createElement("script");

            script.src = "https://cdn01.xiaogj.com/uploads/x3/assets/pc/lib/art-template/4.13.2/art-template.min.js"
            script.onload = e => resolve(window.template)
            script.onerror = err => {
                throw new Error("加载 qrcode.js 失败!")
            }
            window.document.head.appendChild(script);
        }
    })
}


let IScroll;
// 异步获取iscroll
export async function getIScroll() {
    if (!IScroll) {
        IScroll = new Promise(resolve=>{
            var script = document.createElement("script");

            script.src = "https://cdn01.xiaogj.com/uploads/x3/libs/official/iscroll/5.2.0/iscroll-probe-jie.js"
            script.onload = e => resolve(window.IScroll);            
            script.onerror = err => {
                IScroll = null;
                throw new Error("加载 IScroll 失败!");
            }
            window.document.head.appendChild(script);
        })
    }
    return IScroll;
}


// 异步获取Sentry
export async function getSentry() {
    return new Promise(resolve => {
        if (window.Sentry) {
            resolve(window.Sentry)
        } else {
            var script = document.createElement("script");
            script.setAttribute('src', 'https://browser.sentry-cdn.com/6.2.5/bundle.min.js');
            // script.setAttribute('src', 'https://browser.sentry-cdn.com/6.2.5/bundle.tracing.min.js');
            script.setAttribute('crossOrigin', 'anonymous');
        
            script.onload = e => resolve(window.Sentry)
            script.onerror = err => {
                throw new Error("加载 Sentry 失败!")
            }

            window.document.head.appendChild(script);
        }
    })
}
// 异步获取Sentry Vue集成包
export async function getSentryVue() {
    return new Promise(resolve => {
        if (window.Sentry) {
            resolve(window.Sentry)
        } else {
            var script = document.createElement("script");
            script.setAttribute('src', 'https://browser.sentry-cdn.com/6.2.5/vue.min.js');
            script.setAttribute('crossOrigin', 'anonymous');

            script.onload = e => resolve(window.Sentry)
            script.onerror = err => {
                throw new Error("加载 Sentry 失败!")
            }

            window.document.head.appendChild(script);
        }
    })
}

// 异步获取西瓜播放器
export async function getXgplayer() {
    return new Promise(resolve => {
        if (window.Player) {
            resolve(window.Player)
        } else {
            var script = document.createElement("script");

            script.src = "https://cdn01.xiaogj.com/uploads/x3/libs/official/xgplayer/2.32.2/index.min.js"
            script.onload = e => resolve(window.Player)
            script.onerror = err => {
                throw new Error("加载 qrcode.js 失败!")
            }
            window.document.head.appendChild(script);
        }
    })
}

// 异步获取html2canvas
export async function getHtml2canvas() {
    return new Promise(resolve => {
        if (window.html2canvas) {
            resolve(window.html2canvas)
        } else {
            var script = document.createElement("script");

            script.src = "https://cdn01.xiaogj.com/uploads/x3/libs/official/html2canvas/1.4.1/html2canvas.min.js"
            script.onload = e => resolve(window.html2canvas)
            script.onerror = err => {
                throw new Error("加载 html2canvas.js 失败!")
            }
            window.document.head.appendChild(script);
        }
    })
}
